import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";

const state = {
  configs: undefined,
  stateColors: {},
  centralConfigsByName: {},
};

const mutations = {
  setConfigs(state, configs) {
    state.configs = configs;
  },
  setStateColors(state, stateColors) {
    state.stateColors = stateColors;
  },
  setCentralConfigByName(state, { centralId, name, config }) {
    state.centralConfigsByName[centralId] = {
      ...state.centralConfigsByName[centralId],
      [name]: config,
    };
  },
};

const actions = {
  async loadConfigByCentralAndName({ commit, dispatch }, { workgroupId, centralId, name }) {
    const config = await dispatch("getConfigs", {
      idWg: workgroupId,
      idCentral: centralId,
      name,
    });
    commit("setCentralConfigByName", { centralId, name, config });
  },

  async getConfigs({ commit }, customParams) {
    const params = {
      ...customParams,
    };
    try {
      const api = ApiClient();
      let { data } = await api.get("configs", { params });
      if (params.name === "deliveryMode") {
        commit("setConfigs", data);
      } else {
        return data;
      }
    } catch (error) {
      console.error("ERROR en getConfigs: ", error.message);
      throw error;
    }
  },

  async updateConfigs({ rootGetters }, payload) {
    const params = {
      idWg: rootGetters["app/defaultWorkgroup"].id,
      ...payload.params,
    };
    const urlFormData = qs.stringify({ value: JSON.stringify(payload.data) });
    try {
      const api = ApiClient();
      await api.put("configs", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateConfigs: ", error.message);
      return false;
    }
  },

  async loadStateColors({ rootGetters, dispatch, commit }) {
    const stateColors = await dispatch("getConfigs", {
      idWg: rootGetters["app/defaultWorkgroup"].id,
      name: "servicesAndTripsRowsColors",
    });
    commit("setStateColors", stateColors);
  },
};

const getters = {
  configs(state) {
    return state.configs;
  },

  configsMode(state) {
    if (state.configs) {
      return state.configs.mode;
    }
  },

  configsSlotsManualMode(state) {
    if (state.configs) {
      return state.configs.slotManualMode;
    }
  },

  configStateColors(state) {
    return state.stateColors || {};
  },

  centralConfigByName(state) {
    return (centralId, name) => {
      return state.centralConfigsByName[centralId]?.[name] || {};
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
